import { Component, OnInit } from '@angular/core';
import { SaveService } from '../services/save.service';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css'],
  providers: [SaveService]
})
export class AboutUsComponent implements OnInit {
  public isLoggedin: any = false;
  brandName;

  constructor(public SaveService: SaveService) { }

  ngOnInit() {
    this.brandName = this.SaveService.getBrandName();
    let status = window.localStorage.getItem('SkipSignup');
    if (status == 'loggedin') {
      this.isLoggedin = true;
    } else {
      this.isLoggedin = false;
    }
  }

}
